<template>
  <div class="mt-1" >
    <b-row class="centered">
      <b-icon-gear-fill variant="danger" animation="spin" font-scale="4"></b-icon-gear-fill>
      <b-icon-gear-fill animation="spin" font-scale="4"></b-icon-gear-fill>
      <b-icon-gear-fill variant="primary" animation="spin" font-scale="4"></b-icon-gear-fill>
    </b-row>
    <h2 class="centered">Loading...</h2>
  </div>
</template>

<script>
import { BIconGearFill } from "bootstrap-vue";

export default {
  components: {
    BIconGearFill,
  },

};
</script>
<style scoped>

.centered {
  justify-content: center;
  display: flex;
}

</style>